import React from 'react';
import styled from 'styled-components';

export const LogoImage = styled.img.attrs({
    src: "/images/korbank_logo_2026.png"
})`
    width: 250px;
`

export const LoginLogoImage = styled(LogoImage)`
    width: 400px;

    @media(max-width: 800px) {
        width: 80%;
    }
`
